
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4((04|2|86)8|065|16|940|962)|2(292|547|710)|5(115|142|49|758|93)|6(7(15|3|6)|051|080|582|985)|1(138|401|429|509|84|91)|8(1(27|59|80)|9(06|89|95)|(08|71|83)3|29|337|355|438|472|576|757)|7(07[18]|200|261|344|372|453|848|94)|3([89]79|221|233|531|698)|9(077|156|667|730|785))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
